module.exports = __webpack_public_path__ + "img/beijing-北京.a9cc8048.png";